
    if (!window.__swRegistrationAttempted) {
      window.__swRegistrationAttempted = true;
      (async () => {
        const isProduction =
          window.location.hostname !== 'localhost' &&
          window.location.hostname !== '127.0.0.1' &&
          window.location.protocol === 'https:';
        const staticBase = (document.body?.dataset?.staticUrl || '/static/').replace(/\/$/, '');
        const tryImport = async (url) => {
          const mod = await import(/* @vite-ignore */ url);
          const registerServiceWorker = mod.registerServiceWorker ?? mod.default;
          if (typeof registerServiceWorker === 'function') registerServiceWorker();
        };
        const explicit = document.body?.dataset?.swRegistrationUrl?.trim();
        if (explicit) {
          try {
            await tryImport(explicit);
            return;
          } catch (_) {
            /* continue */
          }
        }
        if (isProduction) {
          try {
            const res = await fetch(`${staticBase}/vite-manifest.json`);
            if (res.ok) {
              const manifest = await res.json();
              const chunk = manifest['sw-registration'] || manifest['src/js/sw-registration.js'];
              if (chunk?.file) {
                await tryImport(`${staticBase}/${String(chunk.file).replace(/^\//, '')}`);
                return;
              }
            }
          } catch (_) {
            /* fall through to unhashed try */
          }
          try {
            await tryImport(`${staticBase}/src/js/sw-registration.js`);
          } catch (_) {
            /* ignore */
          }
          return;
        }
        for (const p of ['/src/js/sw-registration.js', `${staticBase}/src/js/sw-registration.js`]) {
          try {
            await tryImport(p);
            return;
          } catch (_) {
            /* next */
          }
        }
      })();
    }
  